










































import * as R from 'ramda'

const enum TableColumnHeaders {
  Exercise = 'Exercise',
  Reps = 'Reps',
  Sets = 'Sets',
  Time = 'Time (min)',
  Equipment = 'Equipment',
  Resistance = 'Resistence',
}

const enum TableColumnProps {
  Exercise = 'exerciseName',
  Reps = 'reps',
  Sets = 'sets',
  Time = 'timeMin',
  Equipment = 'equipment',
  Resistance = 'resistance',
}

export default {
  props: {
    patientExercise: {
      type: Object,
      required: true,
    },
    isGeneratingPdf: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      exercisesForTable: [],
      tableColumnHeaders: [
        TableColumnHeaders.Exercise,
        TableColumnHeaders.Reps,
        TableColumnHeaders.Sets,
        TableColumnHeaders.Time,
        TableColumnHeaders.Equipment,
        TableColumnHeaders.Resistance,
      ],
      tableColumnProps: [
        TableColumnProps.Exercise,
        TableColumnProps.Reps,
        TableColumnProps.Sets,
        TableColumnProps.Time,
        TableColumnProps.Equipment,
        TableColumnProps.Resistance,
      ],
      exerciseNameProp: TableColumnProps.Exercise,
      exerciseTableHeaders: [
        {
          text: 'Exercise',
          value: 'exerciseName',
        },
        {
          text: 'Reps',
          sortable: false,
          value: 'reps',
        },
        {
          text: 'Sets',
          value: 'sets',
        },
        {
          text: 'Time (min)',
          value: 'timeMin',
        },
        {
          text: 'Equipment',
          value: 'equipment',
        },
        {
          text: 'Resistance',
          value: 'resistance',
        },
      ].map(header => ({
        ...header,
        sortable: false,
        divider: true,
        width: '16.6667%',
        class: ['white--text', 'primary'],
        slotName: `item.${header.value}`,
      })),
    }
  },
  computed: {
    cardioExercises() {
      return this.patientExercise.cardioExercises ? this.patientExercise.cardioExercises : []
    },
    strengtheningExercises() {
      return this.patientExercise.strengtheningExercises ? this.patientExercise.strengtheningExercises : []
    },
    combinedExercises() {
      return R.concat(this.cardioExercises, this.strengtheningExercises)
    },
    iterativeExerciseTableHeaders() {
      return this.exerciseTableHeaders.filter(header => header.value !== 'exerciseName')
    },
  },
  mounted() {
    this.buildTableData()
  },
  methods: {
    buildTableData() {
      this.exercisesForTable = [...this.combinedExercises].sort((a, b) => a.order - b.order)
    },
    save(e) {
      console.log(e)
    },
  },
}
